<template>
   <common-form
      form-title="Renewable Energy Information"
      :back-route="this.backRoute"
      :errors="errors.non_field_errors"
      @submit="save"
      @save-and-continue="saveAndContinue"
      >
      <input-field v-model="form.hydro_powers" type="number" label="Hydro power plants" :errors="errors.hydro_powers" required/>
      <input-field v-model="form.micro_hydros" type="number" label="Micro-Hydro plants" :errors="errors.micro_hydros" required/>
      <input-field v-model="form.sub_stations" type="number" label="Sub-station" :errors="errors.sub_stations" required/>
      <input-field v-model="form.transformers" type="number" label="Transformer" :errors="errors.transformers" required/>
      <input-field v-model="form.solar_mini_grids" type="number" label="Solar Mini Grid" :errors="errors.solar_mini_grids" required/>
      <input-field v-model="form.solar_home_systems" type="number" label="Solar home system" :errors="errors.solar_home_systems" required/>
      <input-field v-model="form.improved_water_mills" type="number" label="Improved Water Mill for Electrification" :errors="errors.improved_water_mills" required/>
   </common-form>
</template>

<script>
import CommonForm from '@/components/organisms/Home/Plan/Form'
import InputField from '@/components/molecules/Login/InputField';
import FormMixin from '@/mixins/planform';

export default {
   name: 'renewable-energy-form',
   components: {
      InputField,
      CommonForm,
   },
   data()
   {
      const form = {
         hydro_powers: null,
         micro_hydros: null,
         sub_stations: null,
         transformers: null,
         solar_mini_grids: null,
         solar_home_systems: null,
         improved_water_mills: null,
         plan: this.getPlanId(),
      };

      return {
         form,
         errors: this.getDefaultErrors(form),
         backRoute: {name: 'edit-demography-info',params: {id: this.getPlanId()}},
         nextRoute: {name: 'edit-physical-info',params: {id: this.getPlanId()}},
      };
   },
   mixins: [FormMixin],
   computed: {
      url()
      {
         return `api/plan/${this.getPlanId()}/renewable-energy-info`;
      },
      notificationTitle()
      {
         return 'Renewable Energy Information';
      },
      successMessage()
      {
         return 'Successfuly edited renewable energy information'; 
      },
      errorMessage()
      {
         return "Editing renewable energy information was unsuccessful";
      },
   },
}
</script>
